module.exports = __webpack_public_path__ + "media/images/common/ico-lp-about-docu-df60f5bd1a25e3b723c745926b60e6eb.svg";